import React, { useState, useEffect } from "react";
import { fetchData } from "../../../Components/common/utils";
import { NavLink } from "react-router-dom";
const Our_Video = () => {
  const [selectedVideoId, setSelectedVideoId] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/video/list";
      const result = await fetchData(url);
      if (result) {
        setSelectedVideoId(result.data.slice(0, 1));
        setVideoList(result.data);
      }
      setLoading(false);
    };
    fetchApiData();
  }, []);
  const handleVideoClick = (videoId) => {
    setSelectedVideoId(videoList.filter((item) => item.id === videoId));
  };
  return (
    <>
      <section className="popular-locations py-5">
        <div className="container mt-5">
          <div className="row">
            <h1 className="text-center mb-4">Our Video</h1>
          </div>
          {loading ? (
            <div className="row mt-5">
              <div className="col-md-8 video-height">
                <div
                  style={{ background: "#80808038", height: "30em" }}
                  className="general-img "
                ></div>
              </div>
              <div className="col-md-4 gap-3 video-height ">
                <div className="m-0 placeholder-glow">
                  <span
                    style={{ height: "10em" }}
                    className="placeholder mt-1 col-12"
                  ></span>
                  <span
                    style={{ height: "10em" }}
                    className="placeholder mt-1 col-12"
                  ></span>
                  <span
                    style={{ height: "9em" }}
                    className="placeholder mt-1 col-12"
                  ></span>
                </div>
              </div>
            </div>
          ) : (
            <div className="row mt-5">
              <div className="col-md-8 video-height">
                {selectedVideoId.map((item, index) => (
                  <div key={index} className="general-img ">
                    <iframe
                      width="100%"
                      height="450"
                      src={`https://www.youtube.com/embed/${item.youtube_link}`}
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                    <div style={{ background: "#80808038" }} className="p-2">
                      <h6 className="m-0">{item.title} </h6>
                    </div>
                  </div>
                ))}
              </div>
              <div className="col-md-4 gap-3 video-height ">
                <div style={{ height: "30em", overflowX: "scroll" }}>
                  {videoList.map((video, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        cursor: "pointer",
                        marginBottom: "10px",
                      }}
                    >
                      <iframe
                        width="100%"
                        height="150"
                        src={`https://www.youtube.com/embed/${video.youtube_link}`}
                        frameBorder="0"
                        allowFullScreen
                        style={{ position: "relative", zIndex: 1 }}
                      ></iframe>

                      {/* Overlay div */}
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          zIndex: 2, // Ensures the overlay is above the iframe
                        }}
                        onClick={() => handleVideoClick(video.id)}
                      ></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          <div className="text-center mt-4">
            <NavLink to="/all-videos" className="btn btn-danger">
              View All Videos
            </NavLink>
          </div>
        </div>
      </section>
    </>
  );
};

export default Our_Video;
